<div class="min-h-screen">
  <app-shared-layout
    [Analysis]="title"
    [hideAdd]="true"
    animationSize="full"
    [secondaryWithStyle]="false"
    (closeDetails)="closePanel()"
  >
    <div ngProjectAs="primary-panel">
      <div class="flex flex-col">
        <div class="flex justify-start mt-4">
          <div class="flex items-center gap-3">
            <span
              class="px-4 py-2 text-base font-semibold bg-gradient-to-r from-blue-100 to-blue-200 text-black rounded-xl border border-blue-300 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              {{ zonedata?.name }}
            </span>
          </div>
        </div>

        <div style="height: 0px"></div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-4 xl:grid-cols-5 gap-5">
        <div class="flex flex-col gap-5 md:col-span-1 xl:col-span-1">
          <div class="p-4 rounded-xl shadow-lg flex flex-col h-[350px]">
            <span class="font-bold !text-sm">Realtime Average Temperature</span>
            <div class="grid w-full h-full">
              <div
                class="relative bg-red-50 text-xl lg:text-[2.5vw] xl:text-[2vw] text-red-500 p-2 font-bold flex items-center justify-center h-full"
              >
                <fa-icon [icon]="faTemperature4"></fa-icon>
                {{
                  dashboardRealtimeSummary?.AVG_TEMPERATURE | number : "1.2-2"
                }}&deg;C
                <span
                  class="absolute bottom-0 right-1 text-[10px] text-red-500 uppercase"
                >
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dataPulledAt }}
                </span>
              </div>
            </div>
          </div>

          <div class="p-4 rounded-xl shadow-lg flex flex-col h-[350px]">
            <span class="font-bold !text-sm ">Realtime Average Humidity</span>
            <div class="grid w-full h-full">
              <div
                class="relative text-xl lg:text-[2.5vw] xl:text-[2vw] bg-blue-50 text-blue-500 p-2 font-bold flex items-center justify-center h-full"
              >
                <fa-icon [icon]="faDroplet"></fa-icon>
                {{ dashboardRealtimeSummary?.AVG_HUMIDITY | number : "1.2-2" }}%
                <span
                  class="absolute bottom-0 right-1 text-[10px] text-blue-500 uppercase"
                >
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dataPulledAt }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-5 md:col-span-3 xl:col-span-3">
          <!-- Graph Card – CLEAN & RESPONSIVE -->
          <div class="bg-white rounded-xl shadow-lg p-4 flex flex-col h-full">
            <!-- Title + Tabs -->
            <div
              class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-4"
            >
              <p class="text-md font-bold text-primary ">Temperature and Humidity Readings Visualization</p>

              <div class="w-full sm:w-auto">
                <div
                  class="bg-gray-100 rounded-full flex items-center px-1 h-9"
                >
                  <div class="flex gap-1">
                    @for (tab of lineChartsTabs; track tab) {
                    <button
                      (click)="onTabChange(tab.slug)"
                      [ngClass]="{
                        'bg-primary text-white':
                          activeSlugLineCharts === tab.slug,
                        'text-gray-500': activeSlugLineCharts !== tab.slug
                      }"
                      class="px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition"
                    >
                      {{ tab.name }}
                    </button>
                    }
                  </div>
                </div>
              </div>
            </div>

            <!-- Filters + Live button -->
            <div class="flex flex-col lg:flex-row justify-between gap-4 mb-4">
              <div
                class="flex flex-col sm:flex-row gap-3 items-start sm:items-center"
              >
                <span class="text-sm text-gray-600 whitespace-nowrap"
                  >From</span
                >
                <input
                  type="datetime-local"
                  [(ngModel)]="sixHoursPast"
                  (change)="onTimeChange()"
                  class="px-3 py-2 border rounded text-sm"
                />

                <span class="text-sm text-gray-600 whitespace-nowrap">to</span>
                <input
                  type="datetime-local"
                  [(ngModel)]="currentTime"
                  (change)="onTimeChange()"
                  class="px-3 py-2 border rounded text-sm"
                />
              </div>

              <button
                matTooltip="Click to fetch live graph"
                (click)="setFetchStatus()"
                class="flex items-center gap-2 px-4 py-2 text-black rounded-lg whitespace-nowrap"
              >
                <span
                  class="w-3 h-3 rounded-full"
                  [ngClass]="{
                    'animate-pulse bg-green-500': fetchStatus === 'live',
                    'bg-gray-400': fetchStatus !== 'live'
                  }"
                ></span>
                <span>Live</span>
              </button>
            </div>

            <!-- Chart – takes remaining height -->
            <div class="flex-1 min-h-0">
              <!-- min-h-0 is crucial when using flex-grow inside flex-col -->
              @if (loadingData) {
                  <div class="skeleton-wrapper mt-2">
              <ngx-skeleton-loader
                count="1"
                [theme]="{ height: '100%', width: '100%' }"
              ></ngx-skeleton-loader>
                  </div>
              } @else {
              <app-bar-graph
                *ngIf="showChart"
                [title]="
                  activeSlugLineCharts === 'lineChartsTemp'
                    ? 'Temperature'
                    : 'Humidity'
                "
                [data]="
                  activeSlugLineCharts === 'lineChartsTemp'
                    ? tempLineChartsData
                    : humLineChartsData
                "
                [height]="350"
                [gridX]="true"
                [horizontal]="true"
                [gridY]="true"
                  [height]="580"
                [xAxis]="xAxis"
                [showXlabel]="true"
                [showYlabel]="true"
                columnWidth="25%"
                chart_type="line"
                LegendPosition="top"
                horizontalAlign="right"
              >
              </app-bar-graph>
              }
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-5 md:col-span-4 xl:col-span-1">
          <div class="p-4 rounded-xl shadow-lg flex flex-col flex-1 gap-2">
            <span class="font-bold"></span>
            <div class="grid grid-rows-2 gap-2 h-full">
              <!-- Highest Temperature -->
              <div
                class="bg-red-50 rounded text-2xl text-red-500 p-2 flex flex-col justify-between"
              >
                <div class="flex items-center">
                  <fa-icon [icon]="faTemperature4"></fa-icon>
                  <span class="text-sm font-bold px-2 whitespace-nowrap"
                    >Highest Recorded Temperature</span
                  >
                </div>
                <p class="text-3xl">
                  {{
                    dashboardData?.SUMMARY?.MAX_TEMPERATURE | number : "1.2-2"
                  }}&deg;C
                </p>
                <p class="text-[10px] text-red-400 uppercase">
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dashboardData?.SUMMARY?.MAX_TEMPERATURE_TIMESTAMP }}
                </p>
              </div>

              <!-- Lowest Temperature -->
              <div
                class="bg-red-50 rounded text-2xl text-red-500 p-2 flex flex-col justify-between"
              >
                <div class="flex items-center">
                  <fa-icon [icon]="faTemperature0"></fa-icon>
                  <span class="text-sm font-bold px-2"
                    >Lowest Recorded Temperature</span
                  >
                </div>
                <p class="text-3xl">
                  {{
                    dashboardData?.SUMMARY?.MIN_TEMPERATURE | number : "1.2-2"
                  }}&deg;C
                </p>
                <p class="text-[10px] text-red-400 uppercase">
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dashboardData?.SUMMARY?.MIN_TEMPERATURE_TIMESTAMP }}
                </p>
              </div>
            </div>
          </div>

          <div class="p-4 rounded-xl shadow-lg flex flex-col flex-1 gap-2">
            <span class="font-bold"> </span>
            <div class="grid grid-rows-2 gap-2 h-full">
              <!-- Highest Humidity -->
              <div
                class="bg-blue-50 rounded text-2xl text-blue-500 p-2 flex flex-col justify-between"
              >
                <div class="flex items-center">
                  <fa-icon [icon]="faDroplet"></fa-icon>
                  <span class="text-sm font-bold px-2"
                    >Highest Recorded Humidity</span
                  >
                </div>
                <p class="text-3xl">
                  {{ dashboardData?.SUMMARY?.MAX_HUMIDITY | number : "1.2-2" }}%
                </p>
                <p class="text-[10px] text-blue-400 uppercase">
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dashboardData?.SUMMARY?.MAX_HUMIDITY_TIMESTAMP }}
                </p>
              </div>

              <!-- Lowest Humidity -->
              <div
                class="bg-blue-50 rounded text-2xl text-blue-500 p-2 flex flex-col justify-between"
              >
                <div class="flex items-center">
                  <fa-icon [icon]="faDroplet"></fa-icon>
                  <span class="text-sm font-bold px-2"
                    >Lowest Recorded Humidity</span
                  >
                </div>
                <p class="text-3xl">
                  {{ dashboardData?.SUMMARY?.MIN_HUMIDITY | number : "1.2-2" }}%
                </p>
                <p class="text-[10px] text-blue-400 uppercase">
                  <fa-icon [icon]="faClock"></fa-icon>
                  {{ dashboardData?.SUMMARY?.MIN_HUMIDITY_TIMESTAMP }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="height: 30px"></div>
      <!-- Middle: Bin list -->
      <div class="col-span-12 md:col-span-4">
        <div class="bg-white rounded-xl shadow p-4 h-full">
          <app-bin-list></app-bin-list>
        </div>
      </div>

      <div style="height: 30px"></div>

      <!-- Right: Heatmap -->
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <div class="bg-white rounded-xl shadow p-4 flex flex-col h-full">
          <!-- Tabs -->
          <div class="flex gap-2 mb-3">
            @for (tab of heatmapTabs; track tab) { @if (activeSlug ===
            tab?.slug) {
            <div
              class="bg-primary-50 text-primary-600 shadow px-3 py-1 rounded-xl"
            >
              {{ tab?.name }}
            </div>
            } @else {
            <div
              (click)="activeSlug = tab?.slug"
              class="hover:bg-primary-50/60 hover:text-primary px-3 py-1 rounded-xl cursor-pointer"
            >
              {{ tab?.name }}
            </div>
            } }
          </div>

          <!-- Heatmap table (scrollable if big) -->
          <div class="flex-1 overflow-auto border rounded">
            @if (activeSlug === 'temperature') {
            <table class="w-full bg-gray-100">
              <tbody>
                @for (heatmapData of heatmapDashboardData?.data; track
                heatmapData) {
                <tr class="divide-x-2">
                  <td class="px-3 bg-white font-medium">
                    {{ heatmapData?.serial_number }}
                  </td>
                  @for (binData of heatmapData?.bins; track binData) {
                  <td
                    class="p-2 hover:text-white text-center text-[10px]"
                    matTooltip="Bin: {{ binData }}, Temperature: {{
                      heatmapData?.readings?.temp
                    }}°C"
                    [style.background-color]="
                      'rgba(245, 158, 11, ' +
                      (heatmapData?.tempOpacity || 1) +
                      '%)'
                    "
                  >
                    {{ binData }}
                  </td>
                  }
                </tr>
                }
              </tbody>
            </table>
            } @else {
            <table class="w-full bg-gray-100">
              <tbody>
                @for (heatmapData of heatmapDashboardData?.data; track
                heatmapData) {
                <tr class="divide-x-2">
                  <td class="px-3 bg-white font-medium">
                    {{ heatmapData?.serial_number }}
                  </td>
                  @for (binData of heatmapData?.bins; track binData) {
                  <td
                    class="p-2 hover:text-white text-center text-[10px]"
                    matTooltip="Bin: {{ binData }}, Humidity: {{
                      heatmapData?.readings?.hum
                    }}%"
                    [style.background-color]="
                      'rgba(59, 130, 246, ' +
                      (heatmapData?.humOpacity || 1) +
                      '%)'
                    "
                  >
                    {{ binData }}
                  </td>
                  }
                </tr>
                }
              </tbody>
            </table>
            }
          </div>
        </div>
      </div>
    </div></app-shared-layout
  >
</div>
